import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import ApartmentViewer from "../ApartmentViewer";
import AppDataProviderSelectorComponent from "../functional-components/AppDataProviderSelectorComponent";
import CommandLauncherComponent from "../functional-components/CommandLauncherComponent";
import SceneObjectScopeComponent from "../functional-components/SceneObjectScopeComponent";
import { DataProviderContextEnum } from "../../enums/DataProviderContextEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";
import { useDocumentsStateStore } from "../../store/documentsStateStore";
import { useViewerStateStore, ViewerLoadingStateEnum } from "../../store/viewerStateStore";
import ChecklistItemTypeData from "../../model/sceneObjectData/ChecklistItemTypeData";

// This component is used to display a checklist item in the viewer when the user navigates to the route /checklist-item/:checklistItemId
// checklistItemId can be either the numeric core api checklist item id or the scene object uuid of the checklist item. 

const ChecklistItemViewRouteComponent: React.FC = () => {
  const { checklistItemId } = useParams<{ checklistItemId: string }>();
  const loadingState = useViewerStateStore((state) => state.loadingState);
  const { getActiveDocument, activeDocumentIndex } = useDocumentsStateStore();

  const sceneObjectUuid = useMemo(() => {
    if (loadingState !== ViewerLoadingStateEnum.Staged || activeDocumentIndex === -1 || !checklistItemId) return undefined;
    const contextDoc = getActiveDocument();
    if (!contextDoc) return undefined;
    const numericId = Number(checklistItemId);
    const isNumeric = !isNaN(numericId);
    const so = isNumeric
      ? contextDoc.document.sceneObjects.find(
          (so) =>
            so.data.sceneObjectTypeData instanceof ChecklistItemTypeData &&
            so.data.sceneObjectTypeData.checklistItemId === numericId
        )
      : contextDoc.document.sceneObjects.find(
          (so) => so.data.uuid === checklistItemId
        );
    if (!so) {
      console.error(`ChecklistItemViewRouteComponent: No scene object found for checklistItemId ${checklistItemId}`);
    }
    return so?.data.uuid;
  }, [loadingState, activeDocumentIndex, checklistItemId]);

  return (
    <>
      <AppDataProviderSelectorComponent dataProviderContext={DataProviderContextEnum.Checklist} />
      <SceneObjectScopeComponent uuids={sceneObjectUuid ? [sceneObjectUuid] : []} />
      <ApartmentViewer />
      {sceneObjectUuid && (
        <CommandLauncherComponent commands={[{ commandId: CommandIdEnum.FocusOnSceneObject, parameters: sceneObjectUuid }]} />
      )}
    </>
  );
};

export default ChecklistItemViewRouteComponent;
